import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f94c0fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-float" }

import {watch, ref, computed} from 'vue';
import {useTimStore} from 'v-store/module/tim';
import {goto} from 'common/util';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const timStore = useTimStore();
const groupInfo = computed(() => timStore.groupInfo);

const show = ref(true);

watch([() => timStore.groupInfo.float_img_url, () => timStore.groupInfo.float_jump_url], () => {
    show.value = true;
});

// const close = () => {
//     show.value = false;
// };

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_image, {
      width: "100%",
      height: "100%",
      fit: "cover",
      radius: "24px",
      src: _unref(groupInfo).float_img_url,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goto)(_unref(groupInfo).float_jump_url)))
    }, null, 8 /* PROPS */, ["src"]),
    _createCommentVNode(" <div\n            class=\"icon-close\"\n            @click.stop=\"close\"\n        /> ")
  ], 512 /* NEED_PATCH */)), [
    [_vShow, _unref(groupInfo) && _unref(groupInfo).float_img_url && show.value]
  ])
}
}

})